export default "__VITE_ASSET__1pDUuqwl__"